import { render, staticRenderFns } from "./messageSend.vue?vue&type=template&id=576d16fb&scoped=true&"
import script from "./messageSend.vue?vue&type=script&lang=js&"
export * from "./messageSend.vue?vue&type=script&lang=js&"
import style0 from "./messageSend.vue?vue&type=style&index=0&id=576d16fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576d16fb",
  null
  
)

export default component.exports